import type { AttributeType } from './AttributeComponent';
import type { JobAttribute } from '../../../../__generated__/types.gqlgenerated';

/**
 * Defines attribute keys that should be filtered out (excluded) by type.
 * Add attribute keys to the respective array to prevent them from being displayed.
 */
export const FILTERED_ATTRIBUTES: Record<AttributeType, string[]> = {
    jobTypes: [],
    shiftAndSchedule: [],
    benefits: ['EQH9J'],
};

/**
 * Filters out attributes based on a list of keys to exclude.
 * @param attributes - Array of job attributes to filter
 * @param excludedKeys - Array of attribute keys to filter out
 * @returns Filtered array with excluded attributes removed
 */
export function filterAttributes(
    attributes: JobAttribute[],
    excludedKeys: string[],
): JobAttribute[] {
    if (excludedKeys.length === 0) return attributes;
    return attributes.filter((attr) => !excludedKeys.includes(attr.key));
}

/**
 * Filters out attributes whose label is missing or blank.
 * @param attributes - Array of job attributes to filter
 * @returns Filtered array with unlabeled attributes removed
 */
export function filterAttributesWithLabels(attributes: JobAttribute[]): JobAttribute[] {
    return attributes.filter((attr) => Boolean(attr.label?.trim()));
}

/**
 * Filters out attributes based on the type-specific exclusion list, then
 * drops any remaining attributes that lack a displayable label.
 * @param attributes - Array of job attributes to filter
 * @param type - The attribute type (jobTypes, shiftAndSchedule, or benefits)
 * @returns Filtered array with type-specific excluded and unlabeled attributes removed
 */
export function filterAttributesByType(
    attributes: JobAttribute[],
    type: AttributeType,
): JobAttribute[] {
    const byKey = filterAttributes(attributes, FILTERED_ATTRIBUTES[type]);
    return filterAttributesWithLabels(byKey);
}
